module.exports = __webpack_public_path__ + "static/calle-huertas-zoom-650164b34e45be46a0b608b8e4cbc0a7.jpg";